import { createContext } from 'react';
import { VariablesState } from './hooks/useVariables';
import { WorkspaceKeyPermission } from '~/types/WorkspaceKeyTypes';

type VariablesContextType = {
  variables: VariablesState;
  endpoint: string;
  setVariables: (value: VariablesState) => void;
  permission?: WorkspaceKeyPermission[];
};

export const VariablesContext = createContext<VariablesContextType>({
  variables: {},
  endpoint: '',
  setVariables: () => null,
});
